<template>
    <td :class="roomStatusColor" class="room-cell">
        <!-- ZSH: Disabled menu - cell is read-only -->
        <div class="fill" />
    </td>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component({})
    export class RoomStatusCell extends Vue {
        @Prop() date
        @Prop() service
        @Prop({default: false, type: Boolean}) closed: boolean

        get roomStatus() {
            switch (this.roomStatusColor) {
                case 'bg-green-lighten-2':
                    return 'bookable'
                case 'bg-red-lighten-2':
                    return 'closed'
                default:
                    return 'no_room'
            }
        }

        get roomStatusColor() {
            if (this.closed || this.service.blockout) {
                return 'bg-red-lighten-2'
            }
            switch (this.service.status) {
                case 'NOT_AVAILABLE':
                    return 'bg-grey-lighten-2'
                case 'BLOCKED':
                    return 'bg-red-lighten-2'
                case 'AVAILABLE':
                    return 'bg-green-lighten-2'
                case 'RELEASED':
                case 'UNLIMITED':
                case 'OVERBOOKING':
                    if (this.service.availableQuantity > 0) {
                        return 'bg-green-lighten-2'
                    } else {
                        return 'bg-grey-lighten-2'
                    }
                default:
                    return 'bg-grey-lighten-2'
            }
        }
    }

    export default RoomStatusCell
</script>

<style scoped lang="scss">
    .fill {
        height: 100%;
        pointer-events: none !important;
    }
    .full-width {
        width: 100%;
    }
</style>
